import { UnsplashImage } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetUnsplashImagesPayload = {
  searchText: string;
  page: number;
  pageSize: number;
};

type GetUnsplashImagesRequest = {
  searchText: string;
  limit: number;
  page: number;
};

export type GetUnsplashImagesOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetUnsplashImagesPayload;
};

export const getUnsplashImages = async <TFunctions>(
  options: GetUnsplashImagesOptions<TFunctions>,
): Promise<UnsplashImage[]> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<GetUnsplashImagesRequest, UnsplashImage[]>(
    functions,
    'fetchUnsplashImages-fetchUnsplashImages',
  );

  const { data } = await callable({
    searchText: payload.searchText,
    limit: payload.pageSize,
    page: payload.page,
  });

  return data;
};
